module.exports = {
          srcSet: __webpack_public_path__ + "a6ed21a493ef99abcc18710dddce4f38-185.png"+" 185w",
          images:[ {path: __webpack_public_path__ + "a6ed21a493ef99abcc18710dddce4f38-185.png",width: 185,height: 145}],
          src: __webpack_public_path__ + "a6ed21a493ef99abcc18710dddce4f38-185.png",
          toString:function(){return __webpack_public_path__ + "a6ed21a493ef99abcc18710dddce4f38-185.png"},
          
          width: 185,
          height: 145
        }